import React, { useState } from "react";
import "../styles/products.css";
import { useCart } from "../Cartcontext";
import Logo from "../pictures/mainlogo.png";

import Img1 from "../pictures/tenderloien.jpg";
import Img2 from "../pictures/Entrecote-de-boeuf.jpg";
import Img3 from "../pictures/ribeye.png";
import Img4 from "../pictures/pillets.jpg";
import Img5 from "../pictures/pichama.jpg";
import Img6 from "../pictures/thick sirolin.jpg";
import Img7 from "../pictures/flank.png";
import Img8 from "../pictures/beefstrips.png";
import Img9 from "../pictures/saude.jpg";
import Img10 from "../pictures/sirolien strips.png";
import Img11 from "../pictures/beeftail.png";
import Img12 from "../pictures/roastbeef.jpg";
import Img13 from "../pictures/ribstewmeat.jpg";
import Img14 from "../pictures/beefribslappen.jpg";
import Img15 from "../pictures/Patty__1_.jpg";
const availableMeat = [
  {
    name: "Buffalo Haasbiefstuk",
    englishName: "Tenderloin Steak",
    image: Img1,
    description:
      "Exceptionally tender premium cut with delicate flavour and buttery texture.",
    pricePerKg: 79,
    weightOptions: [
      { kg: 0.258, price: 20.38 },
      { kg: 0.264, price: 20.86 },
      { kg: 0.226, price: 17.85 },
      { kg: 0.286, price: 22.59 },
      { kg: 0.282, price: 22.28 },
      { kg: 0.242, price: 19.12 },
      { kg: 0.222, price: 17.54 },
      { kg: 0.244, price: 19.28 },
      { kg: 0.152, price: 12.01 },
      { kg: 0.174, price: 13.75 },
      { kg: 0.104, price: 8.22 },
      { kg: 0.184, price: 14.54 },
    ],
  },
  {
    name: "Buffalo Entrecote",
    englishName: "Ribeye Steak",
    image: Img2,
    description:
      "Richly marbled premium cut delivering juicy flavour in every bite.",
    pricePerKg: 55.84,
    weightOptions: [
      { kg: 1.018, price: 56.85 },
      { kg: 1.082, price: 60.41 },
      { kg: 0.9, price: 50.26 },
    ],
  },
  {
    name: "Buffalo Kogelbiefstuk",
    englishName: "Eye of Rump Steak",
    image: Img3,
    description:
      "Lean and tender steak perfect for grilling or pan-searing.",
    pricePerKg: 49,
    weightOptions: [{ kg: 0.802, price: 39.3 }],
  },
  {
    name: "Buffalo Rosbief",
    englishName: "Roast Beef",
    image: Img4,
    description:
      "Traditional roasting cut offering excellent flavour and tender slices.",
    pricePerKg: 43,
    weightOptions: [
      { kg: 0.49, price: 21.07 },
      { kg: 0.478, price: 20.55 },
      { kg: 0.462, price: 19.87 },
      { kg: 0.382, price: 16.43 },
      { kg: 0.412, price: 17.72 },
      { kg: 0.342, price: 14.71 },
      { kg: 0.418, price: 17.97 },
    ],
  },
  {
    name: "Buffalo Liesstuk",
    englishName: "Tri-Tip",
    image: Img5,
    description:
      "Juicy triangular cut ideal for grilling, roasting and family meals.",
    pricePerKg: 43,
    weightOptions: [{ kg: 1.352, price: 58.14 }],
  },
  {
    name: "Buffalo Dikke Lende",
    englishName: "Top Sirloin Steak",
    image: Img6,
    description:
      "Flavourful premium steak cut with firm texture and richness.",
    pricePerKg: 38,
    weightOptions: [
      { kg: 0.456, price: 17.33 },
      { kg: 0.508, price: 19.3 },
      { kg: 0.48, price: 18.24 },
      { kg: 0.496, price: 18.85 },
      { kg: 0.486, price: 18.47 },
    ],
  },
  {
    name: "Buffalo Bieflappen",
    englishName: "Beef Steaks",
    image: Img7,
    description:
      "Versatile steak portions perfect for frying, grilling or curries.",
    pricePerKg: 36,
    weightOptions: [
      { kg: 0.572, price: 20.59 },
      { kg: 0.306, price: 11.02 },
      { kg: 0.31, price: 11.16 },
      { kg: 0.33, price: 11.88 },
      { kg: 0.32, price: 11.52 },
      { kg: 0.374, price: 13.46 },
      { kg: 0.44, price: 15.84 },
      { kg: 0.41, price: 14.76 },
      { kg: 0.492, price: 17.71 },
      { kg: 0.476, price: 17.14 },
      { kg: 0.596, price: 21.46 },
      { kg: 0.568, price: 20.45 },
      { kg: 0.584, price: 21.02 },
    ],
  },
  {
    name: "Buffalo Lendelappen",
    englishName: "Sirloin Strips",
    image: Img8,
    description:
      "Tender sliced steak ideal for stir-fries, wraps and quick meals.",
    pricePerKg: 34,
    weightOptions: [
      { kg: 0.804, price: 27.34 },
      { kg: 0.928, price: 31.55 },
      { kg: 0.722, price: 24.55 },
      { kg: 0.824, price: 28.02 },
      { kg: 0.792, price: 26.93 },
    ],
  },
  {
    name: "Buffalo Picanha",
    englishName: "Rump Cap",
    image: Img9,
    description:
      "Brazilian barbecue favourite with rich flavour and juicy texture.",
    pricePerKg: 34,
    weightOptions: [{ kg: 1.22, price: 41.48 }],
  },
];

const otherProducts = [
  {
    name: "Buffalo Sukade",
    englishName: "Chuck Blade Steak",
    image: Img10,
    description:
      "Deeply flavoured cut best suited for slow cooking dishes.",
    pricePerKg: 28,
    weightOptions: [{ kg: 1.952, price: 54.66 }],
  },
  {
    name: "Buffalo Ossenstaart",
    englishName: "Oxtail",
    image: Img11,
    description:
      "Gelatin-rich cut creating rich broths, soups and hearty stews.",
    pricePerKg: 27,
    weightOptions: [{ kg: 1.19, price: 32.13 }],
  },
  {
    name: "Buffalo Braadlappen",
    englishName: "Braising Steak",
    image: Img12,
    description:
      "Slow-cooking favourite becoming tender, juicy and full of flavour.",
    pricePerKg: 26,
    weightOptions: [
      { kg: 0.528, price: 13.73 },
      { kg: 0.61, price: 15.86 },
      { kg: 0.612, price: 15.91 },
      { kg: 0.62, price: 16.12 },
      { kg: 0.612, price: 15.91 },
      { kg: 0.666, price: 17.32 },
      { kg: 1.0, price: 26.0 },
    ],
  },
  {
    name: "Buffalo Stoofvlees",
    englishName: "Stewing Beef",
    image: Img13,
    description:
      "Carefully diced beef perfect for curries, stews and casseroles.",
    pricePerKg: 20,
    weightOptions: [
      { kg: 0.61, price: 12.2 },
      { kg: 0.608, price: 12.16 },
      { kg: 0.878, price: 17.56 },
      { kg: 0.394, price: 7.88 },
      { kg: 0.478, price: 9.56 },
      { kg: 0.468, price: 9.36 },
      { kg: 0.488, price: 9.76 },
      { kg: 0.538, price: 10.76 },
      { kg: 0.53, price: 10.6 },
      { kg: 0.522, price: 10.44 },
    ],
  },
  {
    name: "Buffalo Riblappen",
    englishName: "Short Ribs",
    image: Img14,
    description:
      "Rich meaty ribs ideal for smoking, braising and barbecuing.",
    pricePerKg: 20,
    weightOptions: [
      { kg: 1.874, price: 37.48 },
      { kg: 1.836, price: 36.72 },
      { kg: 2.038, price: 40.76 },
      { kg: 1.672, price: 33.44 },
      { kg: 1.738, price: 34.76 },
      { kg: 1.584, price: 31.68 },
    ],
  },
  {
    name: "Buffalo Burgers",
    englishName: "Premium Buffalo Patties",
    image: Img15,
    description:
      "Handcrafted burgers packed with premium flavour and juicy texture.",
    pricePerKg: null,
    weightOptions: [{ kg: null, label: "In Stock", price: 14.5 }],
  },
];

const ProductCard = ({ item }) => {
  const { addToCart, cartItems } = useCart();
  const [added, setAdded] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState(0);

  const selected = item.weightOptions[selectedIdx];

  const inCart = cartItems.find(
    (i) =>
      i.name === item.name &&
      i.weight === (selected.label ?? `${selected.kg} kg`)
  );

  const handleAdd = () => {
    addToCart({
      name: item.name,
      englishName: item.englishName,
      weight: selected.label ?? `${selected.kg} kg`,
      price: selected.price,
      image: item.image,
    });

    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  return (
    <div className="recipe-card">
      <div className="recipe-image-wrapper">
        <img src={Logo} alt="Company Logo" className="product-logo" />
        <img src={item.image} alt={item.name} className="recipe-image" />

        {inCart && (
          <div className="card-in-cart-badge">{inCart.qty} in cart</div>
        )}
      </div>

      <div className="recipe-content">
        <span className="recipe-category">PREMIUM QUALITY</span>
        <h3 className="recipe-title">{item.name}</h3>
        <p className="recipe-english-name">{item.englishName}</p>
        <p className="recipe-description">{item.description}</p>

        <div className="recipe-footer">
          <div className="recipe-meta">
            <div className="weight-select-wrap">
              <label className="weight-select-label">Weight</label>

              <select
                className="weight-select"
                value={selectedIdx}
                onChange={(e) => setSelectedIdx(Number(e.target.value))}
              >
                {item.weightOptions.map((opt, i) => (
                  <option key={i} value={i}>
                    {opt.label ?? `${opt.kg} kg`}
                  </option>
                ))}
              </select>
            </div>

            <span className="recipe-price">€{selected.price.toFixed(2)}</span>
          </div>

          <button
            className={`add-to-cart-btn ${added ? "added" : ""}`}
            onClick={handleAdd}
          >
            {added ? "✓ Added!" : "+ Add to Cart"}
          </button>
        </div>
      </div>
    </div>
  );
};

const Products = () => {
  return (
    <div className="products-page">
      <div className="products-header">
        <h1>Available Meat Products</h1>
        <p>
          Premium quality buffalo and beef products sourced and processed with
          care.
        </p>
      </div>

      <h2 className="section-title">Premium Cuts</h2>

      <div className="product-grid">
        {availableMeat.map((item, index) => (
          <ProductCard key={index} item={item} />
        ))}
      </div>

      <h2 className="section-title">Other Available Products</h2>

      <div className="product-grid">
        {otherProducts.map((item, index) => (
          <ProductCard key={index} item={item} />
        ))}
      </div>
    </div>
  );
};

export default Products;